import React, { Component } from 'react'
import ToggleCounter from './ToggleCounter';

class ToggleBtn extends Component {
    state = {
        isMounted: true
    };

    toggleMount = () => {
        const { isMounted } = this.state;
        this.setState({ isMounted: !isMounted });
    }

  render() {
      const { isMounted } = this.state;

    return (
      <>
      {isMounted && <ToggleCounter />}
      <button onClick={this.toggleMount}>Toggle</button>  
      <p>
      this.interval is like a state, this can be used inside any component. <br/>
      we made this.interval so that we can use interval in other component also. <br/>
      when a state is changed, render method is called, but on changing this render method will not called. <br/>
      <br/>this.interval = setInterval(() = 
      <br/>this.setState(
      <br/>count: this.state.count + 1
      <br/>)
      <br/>"crly" , 1000);
      <br/>
      <br/>componentWillUnmount() 
      <br/>not setting clear interval will show error
      <br/>clearInterval(this.interval)
      </p>
      </>
    );
  }
}

export default ToggleBtn;
